module.exports = __webpack_public_path__ + "img/广告2.44da2df4.png";